import{b as g}from"./chunk.SCTOUUBO.js";import{b as u}from"./chunk.CUOPQL3Y.js";import{a as h}from"./chunk.2AIXLGYE.js";import{a as n}from"./chunk.NFEB7TIJ.js";import{a as b}from"./chunk.VDLOD2KK.js";import{a as d}from"./chunk.65JZXZ5X.js";import{d as c}from"./chunk.DQ7YBHX4.js";import{a as p}from"./chunk.LWUQDFQZ.js";import{c as o}from"./chunk.NWIV65VP.js";import{property as r,query as m,queryAssignedElements as v,queryAssignedNodes as w,state as l}from"lit/decorators.js";import{classMap as k}from"lit/directives/class-map.js";import{ifDefined as a}from"lit/directives/if-defined.js";import{html as s,literal as y}from"lit/static-html.js";import{when as _}from"lit/directives/when.js";import{css as x}from"lit";var f=x`
  ${h}

  :host([appearance="primary"]) {
    --button-background-color: var(--he-accent-fill-rest);
    --button-background-color-hover: var(--he-accent-fill-hover);
    --button-background-color-active: var(--he-accent-fill-active);
    --button-border-color: transparent;
    --button-foreground-color: var(--he-type-on-accent);
    --divider-color: var(--he-color-neutral-0);
  }

  :host([appearance='primary']) .control:focus-visible {
    --he-focus-ring-color: var(--he-type-on-accent);
  }

  :host([appearance='stealth']) {
    --button-background-color: transparent;
    --button-border-color: transparent;
    --padding-x: var(--he-spacing-x-small);
    border-radius: 0;
  }

  :host([appearance='stealth']) .control:focus-visible {
    box-shadow: inset var(--he-focus-ring);
  }

  :host([appearance='link']) {
    --button-background-color: transparent;
    --button-background-color-hover: transparent;
    --button-background-color-active: transparent;
    --button-border-color: transparent;
    --button-foreground-color: var(--he-accent-foreground-rest);
    --button-foreground-color-hover: var(--he-accent-foreground-hover);
    --button-foreground-color-active: var(--he-accent-foreground-active);
    --icon-spacing: var(--he-spacing-2x-small);
    --padding-x: 0;
    height: auto;
    min-width: 0;
    border-radius: 0;
    line-height: var(--button-line-height, inherit);
    vertical-align: bottom;
  }

  :host([appearance='link']) .control {
    margin: 0;
    padding: 0;
    border: 0;
    white-space: normal;
    line-height: inherit;
    text-align: inherit;
  }

  :host([appearance='link']) .control:focus-visible {
    box-shadow: var(--he-focus-ring);
  }

  :host([appearance='link']) .content {
    display: inline;
    text-decoration: underline;
  }

  :host([appearance='command']) {
    --button-background-color: transparent;
    --button-border-color: transparent;
    --padding-x: var(--he-spacing-x-small);
    border-radius: 0;
  }

  :host([appearance='command']) .control:focus-visible {
    box-shadow: inset var(--he-focus-ring);
  }

  :host([appearance='command']) .start,
  :host([appearance='command']) .icon-only,
  :host([appearance='command'].he-icon-only) .control {
    color: var(--he-accent-foreground-rest);
  }

  :host {
    display: inline-flex;
    --button-background-color: var(--he-neutral-fill-stealth-rest);
    --button-background-color-hover: var(--he-neutral-fill-stealth-hover);
    --button-background-color-active: var(--he-neutral-fill-stealth-active);
    --button-border-color: var(--he-color-neutral-500);
    --button-foreground-color: var(--he-type-primary);
    --button-foreground-color-hover: var(--button-foreground-color);
    --button-foreground-color-active: var(--button-foreground-color);
    --divider-color: var(--he-color-neutral-300); /* used in split buttons */
    --icon-spacing: var(--he-spacing-x-small);
    --padding-x: var(--he-spacing-large);
    --padding-y: 0;
    outline: transparent;
    font-size: var(--button-font-size, var(--he-form-control-font-size));
    font-weight: var(--he-font-weight-normal);
    line-height: var(--button-line-height, var(--he-line-height-normal));
    height: var(--he-form-control-height);
    min-width: var(--he-form-control-height);
    background-color: var(--button-background-color);
    color: var(--button-foreground-color);
    border-radius: var(--he-border-radius-small);
    fill: currentColor;
    cursor: pointer;
    vertical-align: middle;
    align-items: center;
  }

  :host(:hover:not([disabled])) {
    background-color: var(--button-background-color-hover);
    color: var(--button-foreground-color-hover);
  }

  :host(:active:not([disabled])) {
    background-color: var(--button-background-color-active);
    color: var(--button-foreground-color-active);
  }

  :host([disabled]) {
    opacity: var(--he-form-control-disabled-opacity);
    cursor: not-allowed;
  }

  .control {
    background: transparent;
    height: inherit;
    flex-grow: 1;
    box-sizing: border-box;
    display: inline-grid;
    grid-template-columns:
      [padding-start] var(--padding-x) [start] auto [content] 1fr [end] auto
      [internal-icons] auto [padding-end] var(--padding-x) [divider] auto;
    justify-content: center;
    align-items: center;
    padding: var(--padding-y) 0; /* padding-x is set as part of the grid so it won't be outside the divider */
    white-space: nowrap;
    outline: transparent;
    text-decoration: none;
    border: var(--he-form-control-border-width) solid var(--button-border-color);
    color: inherit;
    border-radius: inherit;
    fill: inherit;
    cursor: inherit;
    font-family: inherit;
  }

  .control,
  .end,
  .start {
    font: inherit;
  }

  /* remove padding on icon-only buttons, unless both 'external and 'caret' are on at the same time */
  :host(:not([external][caret])) .control.icon-only,
  :host(.he-icon-only:not([external][caret])) .control {
    --padding-x: 0;
    line-height: 0;
  }

  :host(:not([external][caret])) .control.icon-only .icon,
  :host(.he-icon-only:not([external][caret])) .icon {
    margin-inline-start: 0;
  }

  .control:focus-visible {
    box-shadow: inset 0 0 0 2px var(--button-background-color), inset 0 0 0 3px var(--he-focus-ring-color);
  }

  .control::-moz-focus-inner {
    border: 0;
  }

  .content {
    grid-column: content;
    grid-row: 1;
  }

  .start,
  .end {
    grid-row: 1;
    display: flex;
    align-items: center;
    gap: var(--icon-spacing);
    pointer-events: none;
  }

  .start {
    grid-column: start;
  }

  .end {
    grid-column: end;
  }

  .button--has-start .start,
  .control.icon-only .end,
  :host(.he-icon-only) .end {
    margin-inline-end: var(--icon-spacing);
  }

  .button--has-end .end,
  .control.icon-only .start,
  :host(.he-icon-only) .start {
    margin-inline-start: var(--icon-spacing);
  }

  ::slotted(svg) {
    width: var(--he-icon-size);
    height: var(--he-icon-size);
  }

  ::slotted(svg),
  ::slotted(.he-icon) {
    pointer-events: none;
  }

  .internal-icons {
    grid-column: internal-icons;
    grid-row: 1;
    display: inline-grid;
    align-items: center;
    justify-content: center;
  }

  .control.icon-only .internal-icons,
  :host(.he-icon-only) .internal-icons {
    grid-column: content;
  }

  :host([external][caret]) .control.icon-only .internal-icons,
  :host([external][caret].he-icon-only) .internal-icons {
    gap: var(--icon-spacing);
  }

  .internal-icons .icon {
    grid-row: 1;
    margin-inline-start: var(--icon-spacing);
  }

  .external-icon {
    grid-column: 1;
    margin-top: 1px;
  }

  .caret-icon {
    grid-column: 2;
    font-size: var(--he-chevron-size);
  }

  /*
  * Button groups support a variety of button types (e.g. buttons with callouts, buttons as dropdown triggers, etc.).
  * This means buttons aren't always direct descendants of the button group, thus we can't target them with the
  * ::slotted selector. To work around this, the button group component does some magic to add these special classes to
  * buttons and we style them here instead.
  */
  :host(.he-button-group__button--first),
  :host(.he-button-group__button--inner) {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
  }

  :host(.he-button-group__button--last),
  :host(.he-button-group__button--inner) {
    border-start-start-radius: 0;
    border-end-start-radius: 0;
  }

  :host(.he-button-group__button--first) .control,
  :host(.he-button-group__button--inner) .control {
    border-inline-end-width: 0;
  }

  :host(.he-button-group__button--last) .control,
  :host(.he-button-group__button--inner) .control {
    border-inline-start-width: 0;
  }

  :host(.he-button-group__button) .control::after {
    width: 1px;
    height: calc(50% + (var(--he-form-control-border-width)));
    background: var(--divider-color);
    grid-column: divider;
  }

  :host(.he-button-group__button:not(.he-button-group__button--last)) .control::after {
    content: '';
  }

  :host([appearance='stealth'].he-button-group__button) .control:focus-visible {
    box-shadow: none;
    outline: solid var(--he-focus-ring-width) var(--he-focus-ring-color);
    outline-offset: -3px;
  }

  :host([appearance='link'].he-button-group__button) .control::after {
    display: none;
  }

  :host([appearance='link'].he-button-group__button:not(.he-button-group__button--last))::after {
    content: '';
    width: 1px;
    height: 80%;
    background: var(--divider-color);
    margin-inline-start: var(--he-spacing-x-small);
    margin-inline-end: var(--he-spacing-x-small);
  }

  :host([appearance='command'].he-button-group__button) .control:focus-visible {
    box-shadow: none;
    outline: solid var(--he-focus-ring-width) var(--he-focus-ring-color);
    outline-offset: -3px;
  }

  /** Nav header stuff */
  :host([appearance='stealth'].he-nav-header-action) {
    height: var(--nav-header-height);
    width: var(--nav-header-button-width);
  }

  /* High contrast */
  @media screen and (forced-colors: active) {
    :host,
    :host(:hover:not([disabled])),
    :host(:active:not([disabled])) {
      forced-color-adjust: none;
      background-color: ${n.ButtonFace};
      color: ${n.ButtonText};
      --button-border-color: ${n.ButtonText};
      --divider-color: ${n.ButtonText};
    }

    :host([appearance='primary']),
    :host([appearance='primary']:hover:not([disabled])),
    :host([appearance='primary']:active:not([disabled])) {
      background-color: ${n.Highlight};
      color: ${n.HighlightText};
      --button-border-color: ${n.HighlightText};
      --divider-color: ${n.HighlightText};
    }

    :host([appearance='link']),
    :host([appearance='link']:hover:not([disabled])),
    :host([appearance='link']:active:not([disabled])) {
      background-color: ${n.Canvas};
      color: ${n.LinkText};
      --button-border-color: ${n.LinkText};
    }

    :host([disabled]),
    :host([disabled][appearance]) {
      opacity: 1;
      background-color: ${n.ButtonFace};
      color: ${n.GrayText};
      --button-border-color: ${n.GrayText};
    }

    :host(:hover:not([disabled])) .control,
    :host(:active:not([disabled])) .control,
    .control:focus-visible,
    :host([appearance='stealth']) .control:focus-visible,
    :host([appearance='link']) .control:focus-visible,
    :host([appearance='command'].he-button-group__button) .control:focus-visible,
    :host([appearance='stealth'].he-button-group__button) .control:focus-visible {
      box-shadow: none;
      outline: ${n.ButtonText} solid 2px;
      outline-offset: -3px;
    }

    :host([appearance='link']:hover:not([disabled])) .control,
    :host([appearance='link']:active:not([disabled])) .control,
    :host([appearance='link']) .control:focus-visible {
      outline-offset: 0px;
    }

    .start,
    .end,
    .icon-only,
    :host(.he-icon-only) .control {
      color: inherit;
      fill: currentColor;
    }
  }
`;var t=class extends d{constructor(){super();this.scope=c(this);this.formSubmitController=new p(this,{form:e=>this.form?e.getRootNode().getElementById(this.form):e.closest("form")});this.hasSlotController=new b(this,"[default]","start","end");this.caretIcon=s`<${this.scope.tag("icon")}
    class="icon caret-icon"
    part="caret-icon"
    name="ChevronDown"
  ></${this.scope.tag("icon")}>`;this.externalIcon=s`<${this.scope.tag("icon")}
    class="icon external-icon"
    part="external-icon"
    name="OpenInNewWindow"
    label=${this.localize.term("open_in_new_window")}
  ></${this.scope.tag("icon")}>`;this.hasFocus=!1;this.appearance="secondary";this.type="button";this.referrerPolicy="strict-origin-when-cross-origin";this.scope.registerComponent(u)}click(){var e;(e=this.button)==null||e.click()}focus(e){var i;(i=this.button)==null||i.focus(e)}blur(){var e;(e=this.button)==null||e.blur()}handleBlur(){this.hasFocus=!1,this.emit("he-blur")}handleFocus(){this.hasFocus=!0,this.emit("he-focus")}handleClick(e){if(this.disabled){e.preventDefault(),e.stopPropagation();return}this.type==="submit"&&this.formSubmitController.submit(this),this.type==="reset"&&this.formSubmitController.reset(this)}render(){let e=!!this.href,i=e?y`a`:y`button`;return s`
      <${i}
        part="control"
        class=${k({button:!0,control:!0,[`button--${this.appearance}`]:!0,"button--caret":this.caret,"button--disabled":this.disabled,"button--focused":this.hasFocus,"button--standard":!0,"button--has-content":this.hasSlotController.test("[default]"),"button--has-start":this.startElements.length>0,"button--has-end":this.endElements.length>0,"icon-only":g(this.slottedNodes)})}
        type=${a(e?void 0:this.type)}
        name=${a(e?void 0:this.name)}
        value=${a(e?void 0:this.value)}
        href=${a(e?this.href:void 0)}
        target=${a(e?this.target:void 0)}
        download=${a(e?this.download:void 0)}
        rel=${a(e&&this.target?"noreferrer noopener":void 0)}
        referrerpolicy=${a(e?this.referrerPolicy:void 0)}
        aria-disabled=${this.disabled?"true":"false"}
        aria-current=${a(this.ariaCurrent?this.ariaCurrent:void 0)}
        aria-expanded=${a(this.ariaExpanded?this.ariaExpanded:void 0)}
        aria-pressed=${a(this.ariaPressed?this.ariaPressed:void 0)}
        tabindex=${e&&this.disabled?"-1":"0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @click=${this.handleClick}
      >
        <span part="start" class="start">
          <slot name="start"></slot>
        </span>
        <span part="content" class="content">
          <slot></slot>
        </span>
        <span part="end" class="end">
          <slot name="end"></slot>
        </span>
        ${_(this.caret||this.external,()=>s`
            <span part="icons" class="internal-icons">
              ${this.caret?this.caretIcon:""} ${this.external?this.externalIcon:""}
            </span>
          `)}
      </${i}>
    `}};t.styles=[f],t.baseName="button",t.reactEvents={onHeFocus:new CustomEvent("he-focus"),onHeBlur:new CustomEvent("he-blur")},o([m(".button")],t.prototype,"button",2),o([m(".control")],t.prototype,"control",2),o([w({flatten:!0})],t.prototype,"slottedNodes",2),o([v({slot:"start",flatten:!0})],t.prototype,"startElements",2),o([v({slot:"end",flatten:!0})],t.prototype,"endElements",2),o([l()],t.prototype,"caretIcon",2),o([l()],t.prototype,"externalIcon",2),o([l()],t.prototype,"hasFocus",2),o([r({reflect:!0})],t.prototype,"appearance",2),o([r({type:Boolean,reflect:!0})],t.prototype,"caret",2),o([r({type:Boolean,reflect:!0})],t.prototype,"disabled",2),o([r({type:Boolean,reflect:!0})],t.prototype,"external",2),o([r({reflect:!0})],t.prototype,"type",2),o([r()],t.prototype,"name",2),o([r()],t.prototype,"value",2),o([r()],t.prototype,"href",2),o([r()],t.prototype,"target",2),o([r()],t.prototype,"download",2),o([r()],t.prototype,"form",2),o([r({attribute:"formaction"})],t.prototype,"formAction",2),o([r({attribute:"formmethod"})],t.prototype,"formMethod",2),o([r({attribute:"formnovalidate",type:Boolean,reflect:!0})],t.prototype,"formNoValidate",2),o([r({attribute:"formtarget"})],t.prototype,"formTarget",2),o([r({attribute:"referrerpolicy"})],t.prototype,"referrerPolicy",2),o([r({attribute:"aria-expanded",reflect:!0})],t.prototype,"ariaExpanded",2),o([r({attribute:"aria-pressed",reflect:!0})],t.prototype,"ariaPressed",2),o([r({attribute:"aria-current",reflect:!0})],t.prototype,"ariaCurrent",2);var O=t;export{t as a,O as b};
